import styled from 'styled-components';

export const StyledActivityDateTimePicker = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ActivityDateTimePickerColumn = styled.div`
  flex: 1;
  margin: 0 8px;
  display: flex;
  flex-direction: column;

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }
`;

export const ActivityDateTimePickerCurrentDateTime = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 12px;
  align-items: center;

  > * + * {
    margin-left: 8px;
  }
`;

export const AddUserActivityModalTimePicker = styled.div`
  display: flex;
  flex-direction: row;

  > * + * {
    margin-left: 4px;
  }

  > * {
    flex: 1;
  }
`;

export const ActivityDateTimePickerGroupButton = styled.div<{ amPm }>`
  display: flex;
  flex-direction: row;

  button {
    text-shadow: none;
    height: 46px;
    font-size: 16px;
    font-weight: 400;
    padding: 0 12px;
    border-width: 1px;
    border-style: solid;
    transition: background 0.2s ease;
    flex-shrink: 0;

    &:first-of-type {
      background-color: ${({ amPm }) => (amPm === 'AM' ? '#328dea' : '#fff')};
      color: ${({ amPm }) => (amPm === 'AM' ? '#fff' : '#6C727F')};
      border-color: ${({ amPm }) => (amPm === 'AM' ? '#328dea' : '#ccc')};
      border-radius: 4px 0 0 4px;
      border-right: none;

      &:hover,
      &:active,
      &:focus {
        text-shadow: none;
        background-color: ${({ amPm }) => (amPm === 'AM' ? '#2275d7' : '#f2f2f2')};
      }
    }

    &:last-of-type {
      background-color: ${({ amPm }) => (amPm === 'PM' ? '#328dea' : '#fff')};
      color: ${({ amPm }) => (amPm === 'PM' ? '#fff' : '#6C727F')};
      border-color: ${({ amPm }) => (amPm === 'PM' ? '#328dea' : '#ccc')};
      border-radius: 0 4px 4px 0;
      border-left: none;

      &:hover,
      &:active,
      &:focus {
        text-shadow: none;
        background-color: ${({ amPm }) => (amPm === 'PM' ? '#2275d7' : '#f2f2f2')};
      }
    }
  }
`;
